// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;For you, Lord, have made me glad by your acts,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and I sing aloud at the works of your hands.<br> </p> </div></div>";
// Exports
module.exports = code;